import React from 'react';

import Footer from './footer';

export default React.memo(Footer);
